module.exports = __webpack_public_path__ + "static/media/demo.b4d688fd.jpg";